import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { SearchableSelect } from "./SearchableSelect";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "./ui/dialog";
import { toast } from "sonner";

export const DeliveryWarrantyDialog = ({ delivery, onClose, onDone }) => {
  const [mode, setMode] = useState("new");
  const [type, setType] = useState("reposicion");
  const [title, setTitle] = useState("");
  const [wid, setWid] = useState("");
  const [types, setTypes] = useState([]);
  const [open, setOpen] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!delivery) { return; }
    setMode("new"); setType("reposicion"); setTitle(""); setWid("");
    api.get("/warranties/meta").then((m) => setTypes(m.data.types)).catch(() => {});
    api.get("/warranties").then((r) => setOpen(r.data.filter((w) => !w.delivery_id && !["Cerrado", "Cancelado"].includes(w.status)))).catch(() => setOpen([]));
  }, [delivery]);

  const save = async () => {
    if (mode === "existing" && !wid) return toast.error("Selecciona la garantía");
    setSaving(true);
    try {
      const r = await api.post(`/deliveries/${delivery.id}/warranty`, mode === "existing" ? { warranty_id: wid } : { type, title });
      toast.success(`Envío ligado a ${r.data.number}`);
      onClose(); onDone();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={!!delivery} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-sm max-w-md" data-testid="delivery-warranty-dialog">
        <DialogHeader><DialogTitle className="font-heading">Ligar {delivery?.number} a garantía</DialogTitle>
          <DialogDescription>El envío quedará como reposición: se descuenta del inventario, no cuenta como venta y su costo pasa a la garantía.</DialogDescription></DialogHeader>
        <div className="space-y-3">
          <Select value={mode} onValueChange={setMode}>
            <SelectTrigger className="rounded-sm" data-testid="delivery-warranty-mode"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="new">Crear nuevo registro</SelectItem><SelectItem value="existing">Ligar a un registro existente</SelectItem></SelectContent>
          </Select>
          {mode === "new" ? (<>
            <div className="space-y-1.5"><Label className="text-xs font-bold uppercase tracking-widest">Tipo</Label>
              <Select value={type} onValueChange={setType}>
                <SelectTrigger className="rounded-sm" data-testid="delivery-warranty-type"><SelectValue /></SelectTrigger>
                <SelectContent>{types.map((t) => <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>)}</SelectContent></Select></div>
            <div className="space-y-1.5"><Label className="text-xs font-bold uppercase tracking-widest">Descripción</Label>
              <Input className="rounded-sm" value={title} onChange={(e) => setTitle(e.target.value)} placeholder={`Reposición entregada con envío ${delivery?.number || ""}`} data-testid="delivery-warranty-title" /></div>
          </>) : (
            <div className="space-y-1.5"><Label className="text-xs font-bold uppercase tracking-widest">Registro abierto</Label>
              <SearchableSelect value={wid} onChange={setWid} testid="delivery-warranty-pick" placeholder="Selecciona garantía" searchPlaceholder="Buscar..."
                options={open.map((w) => ({ value: w.id, label: `${w.number} · ${w.client_name || "Sin cliente"} · ${w.title}` }))} /></div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" className="rounded-sm" onClick={onClose}>Cancelar</Button>
          <Button className="rounded-sm font-bold" onClick={save} disabled={saving} data-testid="delivery-warranty-save">{saving ? "Guardando..." : "Ligar"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
